import {
    FETCH_ACTIVE_DAY,
    UPDATE_ACTIVE_DAY,
    VALIDATE_DAY,
    VALIDATE_DAY_SEND_DATA_SUCCESS,
    CAN_VALIDATE_DAY,
    SET_ALL_DAYS,
} from "./dayConstants";
import { setValue } from "../../lib/immutable_wrapper";

const initialState = {
    allDays: [],
};

export function allDays(state = initialState, action) {
    switch (action.type) {
        case SET_ALL_DAYS:
            return setValue(state, ["allDays"], action.allDays);
        default:
            return state;
    }
}

export function current_day(state = false, action) {
    switch (action.type) {
        case FETCH_ACTIVE_DAY:
            return action.payload;
        case UPDATE_ACTIVE_DAY:
            return action.payload;
        case VALIDATE_DAY:
            return action.payload;
        case VALIDATE_DAY_SEND_DATA_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function dayValidationAuthorized(state = false, action) {
    switch (action.type) {
        case CAN_VALIDATE_DAY:
            return action.payload;
        case FETCH_ACTIVE_DAY:
            if (action.isValidationAuthorized !== null) {
                return action.isValidationAuthorized;
            }
            return false;
        case VALIDATE_DAY:
            return false;
        case VALIDATE_DAY_SEND_DATA_SUCCESS:
            return false;
        default:
            return state;
    }
}

export function dayModificationAuthorized(state = false, action) {
    switch (action.type) {
        case FETCH_ACTIVE_DAY:
            if (action.isModificationAuthorized !== null) {
                return action.isModificationAuthorized;
            }
            return false;
        default:
            return state;
    }
}
